// extracted by mini-css-extract-plugin
export default {"skeleton":"DMtd7pPFg7icrtaraj04","pulse":"QjfQyOgoxW3fUeixa4Ym"};